import { algoliasearch } from "algoliasearch"
import env from "decentraland-gatsby/dist/utils/env"

import type {
  SearchResponse,
  SearchSingleIndexProps,
} from "@algolia/client-search"

export type AlgoliaSearch = {
  title: string
  description: string
  id: string
  imageObject: { sys: Record<"type" | "linkType" | "id", string> }
  categoryObject: { sys: Record<"type" | "linkType" | "id", string> }
}

const searchClient = algoliasearch(
  env("ALGOLIA_APP_KEY")!,
  env("ALGOLIA_READY_KEY")!
)

export const searchBlog = async (
  query: string,
  options: Omit<SearchSingleIndexProps["searchParams"], "query">
) => {
  // Prevent the query to be sent if it's too short
  if (query.trim().length <= 2) {
    return {
      hits: [],
      nbHits: 0,
      nbPages: 0,
      page: 0,
      hitsPerPage: 20,
      processingTimeMS: 0,
      query,
      params: "",
      exhaustiveNbHits: true,
      exhaustiveFacetsCount: true,
      facets: {},
      facets_stats: {},
    } as SearchResponse<AlgoliaSearch>
  }
  return searchClient.searchSingleIndex<AlgoliaSearch>({
    indexName: env("ALGOLIA_BLOG_INDEX")!,
    searchParams: {
      query,
      ...options,
    },
  })
}
